import ClusteringAnnotationIndexComponent from './component';

class ClusteringAnnotationIndexRoute extends ClusteringAnnotationIndexComponent {
}

export default ClusteringAnnotationIndexRoute;
